// Simple Armour Customizer JavaScript with Data-Driven Steps
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("armour-customizer-form");
  const nextButton = document.getElementById("next-button");
  const backButton = document.getElementById("back-button");
  const addToCartButton = document.getElementById("add-to-cart-button");
  const currentStepSpan = document.getElementById("current-step");
  const totalStepsSpan = document.getElementById("total-steps");

  // Step configuration - easily extensible
  const STEP_CONFIG = [
    {
      id: "step-variants",
      title: "Options",
      element: null,
      validate: () => true, // No validation needed for variant selection
      shouldSkip: () => hasOnlyDefaultVariant,
    },
    {
      id: "step-measurements",
      title: "Measurements",
      element: null,
      validate: validateMeasurements,
      shouldSkip: () => false,
    },
    {
      id: "step-review",
      title: "Review",
      element: null,
      validate: () => true,
      shouldSkip: () => false,
      onEnter: updateOrderSummary,
    },
  ];

  let currentStepIndex = 0;
  let activeSteps = [];
  let basePrice = parseInt(form.dataset.basePrice) || 0;

  // Product data for variant matching
  let productOptions = [];
  let variants = [];
  let currency = "USD";
  let hasOnlyDefaultVariant = false;
  let customerMeasurements = null;

  // Load product data
  const dataEl = document.getElementById("armour-customizer-data");
  if (dataEl) {
    try {
      const data = JSON.parse(dataEl.textContent);
      productOptions = Array.isArray(data.options) ? data.options : [];
      variants = Array.isArray(data.variants) ? data.variants : [];
      currency = data.currency || currency;
      hasOnlyDefaultVariant = data.has_only_default_variant || false;
      customerMeasurements = data.customer_measurements || null;
      console.log("[Customizer] Data loaded", {
        optionsCount: Array.isArray(productOptions) ? productOptions.length : 0,
        variantsCount: Array.isArray(variants) ? variants.length : 0,
        currency,
        hasOnlyDefaultVariant,
        hasCustomerMeasurements: !!customerMeasurements,
      });
    } catch (e) {
      console.error("[Customizer] Error loading data:", e);
    }
  }

  // Initialize step elements and filter active steps
  function initializeSteps() {
    STEP_CONFIG.forEach((step) => {
      step.element = document.getElementById(step.id);
    });

    activeSteps = STEP_CONFIG.filter((step) => !step.shouldSkip());

    // Find the first step index
    currentStepIndex = 0;

    console.log(
      "[Customizer] Active steps:",
      activeSteps.map((s) => s.id),
    );
  }

  // Initialize
  initializeSteps();
  totalStepsSpan.textContent = activeSteps.length;
  updateStepDisplay();
  updateStepIndicators();
  updatePricing();
  tryPrefillMeasurements();

  // Event listeners
  if (nextButton) nextButton.addEventListener("click", nextStep);
  if (backButton) backButton.addEventListener("click", previousStep);
  if (addToCartButton) addToCartButton.addEventListener("click", addToCart);

  // Form change listeners
  form.addEventListener("change", handleFormChange);
  form.addEventListener("input", handleFormInput);

  function validateMeasurements() {
    const currentStep = activeSteps[currentStepIndex];
    if (!currentStep || !currentStep.element) return true;

    const requiredInputs =
      currentStep.element.querySelectorAll("input[required]");
    let allFilled = true;

    requiredInputs.forEach((input) => {
      if (!input.value || input.value.trim() === "") {
        allFilled = false;
      }
    });

    if (!allFilled) {
      alert("Please fill in all required measurements.");
    }

    return allFilled;
  }

  function nextStep() {
    if (currentStepIndex >= activeSteps.length - 1) return;

    const currentStep = activeSteps[currentStepIndex];

    // Validate current step before proceeding
    if (currentStep.validate && !currentStep.validate()) {
      return;
    }

    currentStepIndex++;
    updateStepDisplay();
  }

  function previousStep() {
    if (currentStepIndex <= 0) return;

    currentStepIndex--;
    updateStepDisplay();
  }

  function updateStepDisplay() {
    // Hide all steps
    STEP_CONFIG.forEach((step) => {
      if (step.element) {
        step.element.classList.add("hidden");
        step.element.classList.remove("active");
      }
    });

    // Show current active step
    const currentStep = activeSteps[currentStepIndex];
    if (currentStep && currentStep.element) {
      currentStep.element.classList.remove("hidden");
      currentStep.element.classList.add("active");

      // Call onEnter callback if defined
      if (currentStep.onEnter) {
        currentStep.onEnter();
      }
    }

    // Update step counter (1-indexed for display)
    currentStepSpan.textContent = currentStepIndex + 1;

    // Update navigation buttons
    const isFirstStep = currentStepIndex === 0;
    const isLastStep = currentStepIndex === activeSteps.length - 1;

    if (backButton) {
      backButton.disabled = isFirstStep;
    }

    if (nextButton) {
      nextButton.classList.toggle("hidden", isLastStep);
    }

    if (addToCartButton) {
      addToCartButton.classList.toggle("hidden", !isLastStep);
      addToCartButton.disabled = false;
    }

    updateStepIndicators();
  }

  function updateStepIndicators() {
    const stepIndicators = document.getElementById("step-indicators");
    if (!stepIndicators) return;

    let html = "";

    activeSteps.forEach((step, index) => {
      let classes =
        "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium";

      if (index < currentStepIndex) {
        classes += " bg-green-500 text-white";
      } else if (index === currentStepIndex) {
        classes += " bg-primary text-white";
      } else {
        classes += " bg-gray-200 text-gray-600";
      }

      const isNotLast = index < activeSteps.length - 1;
      const stepNumber = index + 1;

      html += `
        <div class="flex items-center gap-2 ${isNotLast ? "flex-1" : ""}">
          <div class="${classes}">
            ${index < currentStepIndex ? "✓" : stepNumber}
          </div>
          <span class="text-sm font-medium text-gray-700 hidden sm:inline">${step.title}</span>
          ${isNotLast ? '<div class="flex-1 h-px bg-gray-300 mx-4"></div>' : ""}
        </div>
      `;
    });

    stepIndicators.innerHTML = html;
  }

  function handleFormChange(e) {
    if (e.target.type === "radio" || e.target.type === "checkbox") {
      updateVariantSelection(e.target);
      updatePricing();
    }
  }

  function handleFormInput(e) {
    // Update order summary in real-time if on review step
    const currentStep = activeSteps[currentStepIndex];
    if (currentStep && currentStep.id === "step-review") {
      updateOrderSummary();
    }
  }

  function getSelectedOptions() {
    const values = [];
    productOptions.forEach((name) => {
      const checked = form.querySelector(`input[name="${name}"]:checked`);
      values.push(checked ? checked.value : undefined);
    });
    return values;
  }

  function findVariantByOptions(values) {
    return variants.find((variant) => {
      if (!variant) return false;

      // Check each option position
      for (let i = 0; i < values.length && i < 3; i++) {
        if (values[i] !== undefined) {
          const variantOption =
            i === 0
              ? variant.option1
              : i === 1
                ? variant.option2
                : variant.option3;
          if (variantOption !== values[i]) return false;
        }
      }
      return true;
    });
  }

  function getSelectedVariant() {
    const values = getSelectedOptions();
    console.log("Selected options:", values);
    console.log("Available variants:", variants);
    console.log("Product options:", productOptions);

    const variant = findVariantByOptions(values);
    console.log("Found variant:", variant);
    return variant;
  }

  function updateVariantSelection(input) {
    // Update visual selection for radio buttons
    if (input.type === "radio") {
      const group = document.querySelectorAll(`input[name="${input.name}"]`);
      group.forEach((radio) => {
        const label = radio.closest("label");
        if (radio.checked) {
          label.classList.add("border-primary", "bg-blue-50");
          label.classList.remove("border-gray-200");
          const indicator = label.querySelector(".selection-indicator");
          if (indicator) {
            indicator.classList.add("border-primary");
            indicator.classList.remove("border-gray-300");
            const dot = indicator.querySelector("div");
            if (dot) dot.classList.remove("hidden");
          }
        } else {
          label.classList.remove("border-primary", "bg-blue-50");
          label.classList.add("border-gray-200");
          const indicator = label.querySelector(".selection-indicator");
          if (indicator) {
            indicator.classList.remove("border-primary");
            indicator.classList.add("border-gray-300");
            const dot = indicator.querySelector("div");
            if (dot) dot.classList.add("hidden");
          }
        }
      });
    }

    // Update visual selection for checkboxes
    if (input.type === "checkbox") {
      const label = input.closest("label");
      if (input.checked) {
        label.classList.add("bg-blue-50", "border-blue-200");
      } else {
        label.classList.remove("bg-blue-50", "border-blue-200");
      }
    }
  }

  function updatePricing() {
    const variant = getSelectedVariant() || variants[0] || null;
    const variantPrice =
      variant && typeof variant.price === "number" ? variant.price : basePrice;
    const total = variantPrice;

    const totalPriceEl = document.getElementById("total-price");
    if (totalPriceEl) totalPriceEl.textContent = formatPrice(total);

    const customizationsRow = document.getElementById("customizations-row");
    if (customizationsRow) customizationsRow.classList.add("hidden");
  }

  function formatPrice(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function tryPrefillMeasurements() {
    const banner = document.getElementById("measurement-autofill-banner");
    const guestPrompt = document.getElementById("guest-login-prompt");
    const successMessage = document.getElementById("autofill-success-message");
    const countSpan = document.getElementById("autofill-count");

    // Show banner
    if (banner) {
      banner.classList.remove("hidden");
    }

    // If no customer measurements, show guest login prompt
    if (!customerMeasurements || typeof customerMeasurements !== "object") {
      if (guestPrompt) {
        guestPrompt.classList.remove("hidden");
      }
      if (successMessage) {
        successMessage.classList.add("hidden");
      }
      return;
    }

    console.log("[Customizer] Prefill: starting with customer measurements");
    const handleToValue = {};
    Object.entries(customerMeasurements).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      console.log("[Customizer] Prefill: key", key, "value", value);
      // Convert metafield key to handle format
      // Example: "a_-_total_height" -> "a-total-height"
      // The pattern _-_ represents " - " in the title, which becomes a single "-" when handleized
      const handle = String(key).replace(/_-_/g, "-").replace(/_/g, "-");
      console.log("[Customizer] Prefill: handle", handle);
      handleToValue[handle] = value;
    });
    console.log(
      "[Customizer] Prefill: mapped handles ->",
      Object.keys(handleToValue),
    );

    const inputs = document.querySelectorAll("input[data-measurement-handle]");
    let filledCount = 0;
    inputs.forEach((input) => {
      const handle = input.getAttribute("data-measurement-handle");
      if (!handle) return;
      const val = handleToValue[handle];
      if (val === undefined || val === null || val === "") return;
      input.value = val;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      filledCount += 1;
      console.log(`[Customizer] Prefill set ${handle} = ${val}`);
    });
    console.log(
      `[Customizer] Prefill complete: ${filledCount}/${inputs.length} inputs filled`,
    );

    // Show appropriate notification
    if (filledCount > 0) {
      // Show success message with count
      if (successMessage) {
        successMessage.classList.remove("hidden");
      }
      if (guestPrompt) {
        guestPrompt.classList.add("hidden");
      }
      if (countSpan) {
        countSpan.textContent = filledCount;
      }
    } else {
      // Logged in but no measurements saved
      if (guestPrompt) {
        guestPrompt.classList.remove("hidden");
      }
      if (successMessage) {
        successMessage.classList.add("hidden");
      }
    }
  }

  function updateOrderSummary() {
    const orderSummary = document.getElementById("order-summary");
    if (!orderSummary) return;

    let html = '<dl class="space-y-3">';

    // Collect selected variants
    const variantInputs = form.querySelectorAll("input.variant-input:checked");
    variantInputs.forEach((input) => {
      const fieldset = input.closest("fieldset");
      const legend = fieldset ? fieldset.querySelector("legend") : null;
      if (legend && input.value) {
        html += `
          <div class="flex justify-between">
            <dt class="text-sm text-gray-600">${legend.textContent}:</dt>
            <dd class="text-sm font-medium text-gray-900">${input.value}</dd>
          </div>
        `;
      }
    });

    // Collect measurements
    const measurementInputs = form.querySelectorAll(
      "input[data-measurement-handle]",
    );
    measurementInputs.forEach((input) => {
      if (input.value && input.value.trim() !== "") {
        const label = form.querySelector(`label[for="${input.id}"]`);
        let labelText = label
          ? label.textContent.replace("*", "").trim()
          : input.name;

        html += `
          <div class="flex justify-between">
            <dt class="text-sm text-gray-600">${labelText}:</dt>
            <dd class="text-sm font-medium text-gray-900">${input.value} cm</dd>
          </div>
        `;
      }
    });

    html += "</dl>";
    orderSummary.innerHTML = html;
  }

  async function addToCart() {
    addToCartButton.disabled = true;
    addToCartButton.textContent = "Adding to Cart...";

    try {
      let variantId = null;

      if (hasOnlyDefaultVariant) {
        // For products with only default variant, use the first variant
        if (variants.length > 0) {
          variantId = variants[0].id;
          console.log("Using default variant:", variants[0]);
        }
      } else {
        // Find the matching variant based on all selected options
        const selectedOptions = [];
        const variantInputs = form.querySelectorAll(
          "input.variant-input:checked",
        );

        // Collect selected option values
        variantInputs.forEach((input) => {
          selectedOptions.push(input.value);
        });

        console.log("Selected option values:", selectedOptions);

        // Find matching variant
        const matchingVariant = variants.find((variant) => {
          const variantOptions = [
            variant.option1,
            variant.option2,
            variant.option3,
          ].filter(Boolean);
          console.log(
            "Comparing variant options:",
            variantOptions,
            "with selected:",
            selectedOptions,
          );

          // Check if all selected options match this variant
          return (
            selectedOptions.every((selected) =>
              variantOptions.includes(selected),
            ) && variantOptions.length === selectedOptions.length
          );
        });

        if (matchingVariant) {
          variantId = matchingVariant.id;
          console.log("Found matching variant:", matchingVariant);
        }
      }

      if (!variantId) {
        throw new Error("Please select all required options");
      }

      // Collect form data
      const formData = new FormData(form);
      const properties = {};

      for (let [key, value] of formData.entries()) {
        if (!value || value.trim() === "") continue;
        if (key === "quantity") continue;
        if (productOptions.includes(key)) continue; // skip variant options

        // Get the input element
        const input = form.querySelector(`input[name="${key}"]`);
        if (!input) continue;

        // Get the label text (keep prefixes for merchant reference)
        const label = form.querySelector(`label[for="${input.id}"]`);
        let labelText = label ? label.textContent.replace("*", "").trim() : key;

        properties[labelText] = value + " cm";
      }

      const payload = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties,
          },
        ],
      };

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.message || "Failed to add to cart");
      }

      window.location.href = "/cart";
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert(error.message || "Error adding to cart. Please try again.");
    } finally {
      addToCartButton.disabled = false;
      addToCartButton.textContent = "Add to Cart";
    }
  }
});
